import toastcom from './toast.vue'
const toast = {}
toast.install = vue => {
  const ToastCon = vue.extend(toastcom)
  const ins = new ToastCon()
  ins.$mount(document.createElement('div'))
  document.body.appendChild(ins.$el)
  // vue.prototype.$toast = (msg, duration = 1000) => {
  //   ins.show(msg, duration)
  // }
  vue.prototype.$toast = ins
}
export default toast



// WEBPACK FOOTER //
// ./src/components/include/toast/index.js